import { render, staticRenderFns } from "./VaffMediaUpload.vue?vue&type=template&id=41d82b70&"
import script from "./VaffMediaUpload.vue?vue&type=script&lang=js&"
export * from "./VaffMediaUpload.vue?vue&type=script&lang=js&"
import style0 from "./VaffMediaUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports